export function numberCap(num: number, cap: number): string {
  if (num < cap) return String(num);

  return '+' + cap;
}
